import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PageNames} from '../../constants/page-names.const';
import {CatalogsMapService} from '../../_pages/catalogs/services/catalogs-map.service';
import {CatalogObj} from '../../_pages/catalogs/models/catalog-obj';
import { UserAuthorities } from 'src/app/_shared/modules/agri-auth/constants/user-authorities.const';
import { SessionQuery } from 'src/app/_shared/modules/agri-auth/state/session';
import { ClrDropdown } from '@clr/angular';

@Component({
  selector: 'app-actions-dropdown',
  templateUrl: './actions-dropdown.component.html',
  styleUrls: ['./actions-dropdown.component.scss']
})
export class ActionsDropdownComponent implements OnInit {

  @Input() pageName: PageNames;

  @Input() soilAnalysisUploading: boolean;

  @Output() filesAdded: EventEmitter<File[]> = new EventEmitter<File[]>();

  isAdmin$ = this.sessionQuery.hasAuthority(UserAuthorities.ROLE_ADMIN);

  showInnerDropdown: boolean;
  @ViewChild(ClrDropdown) dropdown: ClrDropdown;


  catalogs: CatalogObj[] = this.catalogsMapService.catalogsByType;

  pageNames = PageNames;

  constructor(
    private catalogsMapService: CatalogsMapService,
    private sessionQuery: SessionQuery,
  ) { }

  ngOnInit() {
  }

  closeDropdown(): void {
    this.showInnerDropdown = false;
    if (this.dropdown && this.dropdown.ifOpenService) {
      this.dropdown.ifOpenService.open = false;
    }
  }

}
